<template>
  <div class="d-flex flex-column flex-grow-1">
    <!-- success section -->
    <div class="d-flex flex-column justify-center justify-baseline">
      <v-icon
        x-large
        :color="iconColor"
        style="font-size: 120px;"
      >
        {{ icon }}
      </v-icon>

      <p class="text-h3 py-5">
        {{ title }}
      </p>
      <p>
        {{ subtitle }}
      </p>
    </div>

    <!-- info section -->
    <v-row class="flex-grow-0 py-0 pt-3 my-0 text-subtitle-1">
      <slot />
    </v-row>

    <!-- footer -->
    <div class="flex-grow-1 d-flex flex-column justify-end">
      <i18n
        :path="footerPath"
        tag="span"
        class="text-body-2"
      >
        <span v-if="!slots['footer-content']">
          <span class="font-weight-medium">{{ $t('title.settings') }}</span> →
          <span class="font-weight-medium">{{ $t('title.account') }}</span>  →
          <span class="font-weight-medium">{{ $t('title.billing') }}</span>
        </span>
        <slot
          v-else
          name="footer-content"
        />
      </i18n>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType, useSlots } from 'vue';
import { TranslateResult } from 'vue-i18n';

const slots = useSlots();

const props = defineProps({
  icon: { type: String, required: true },
  iconColor: { type: String, required: false, default: 'success' },
  title: { type: [String, Object] as PropType<string|TranslateResult>, required: true },
  subtitle: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: undefined },
  footerPath: { type: String, required: false, default: 'message.billing_method_setup' },
});

</script>
